export const companyInfo = {
  name: "Casa Funerară Sfântul Andrei",
  city: "Constanța",
  slogan: "Sprijin complet în cele mai grele momente.",
  founded: 2019,
  experience: "10 ani",
  phone: "+40 786 135 139",
  phoneSecondary: "+40 762 00 96 76",
  whatsapp: "+40786135139",
  schedule: "NON-STOP 24/7",
  logo: "/images/logo.png",
  addresses: [
    {
      name: "Sediul Constanța",
      street: "Strada Trandafirului 42",
      postalCode: "900350",
      city: "Constanța",
      mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8!2d28.6348!3d44.1765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40bae5ed5adae363%3A0x55948c548c1c16da!2sStrada+Trandafirului+42%2C+900350+Constan%C8%9Ba!5e0!3m2!1sro!2sro",
      mapLink: "https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUqBggAEEUYOzIGCAAQRRg7MgYIARBFGDsyBggCEEUYOzIICAMQABgWGB4yBwgEEAAY7wUyBggFEEUYPDIGCAYQRRg8MgYIBxBFGDzSAQg1Nzk1ajBqN6gCALACAA&um=1&ie=UTF-8&fb=1&gl=ro&sa=X&geocode=KWPTWu2f5bpAMRbaHIZUjJVV&daddr=Strada+Trandafirului+42,+900350+Constan%C8%9Ba",
    },
    {
      name: "Sediul Lumina",
      street: "Str. Mare nr. 136",
      postalCode: "907175",
      city: "Comuna Lumina",
      mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11395.4!2d28.6024437!3d44.2105856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40baf40b3afb3b91%3A0xa755fe5d43e60dd6!2sCasa+Funerara+Sf%C3%A2ntul+Andrei!5e0!3m2!1sro!2sro",
      mapLink: "https://www.google.com/maps/dir//Casa+Funerara+Sf%C3%A2ntul+Andrei,+Strada+Mare+136,+907175+Lumina/@44.2105856,28.6024437,14z/data=!4m8!4m7!1m0!1m5!1m1!1s0x40baf40b3afb3b91:0xa755fe5d43e60dd6!2m2!1d28.5675332!2d44.2908059",
    },
  ],
};

export const whyChooseUs = [
  {
    title: "NON-STOP 24/7",
    description: "Suntem disponibili zi și noapte, în orice moment aveți nevoie de sprijin. Nu trebuie să așteptați.",
    icon: "Clock",
  },
  {
    title: "Ne ocupăm de toate actele",
    description: "Întocmim complet documentația necesară: certificat de deces, acte de transport, autorizații.",
    icon: "FileText",
  },
  {
    title: "Experiență 10 ani",
    description: "Echipa noastră are peste un deceniu de experiență în servicii funerare, oferind profesionalism de excepție.",
    icon: "Award",
  },
  {
    title: "Autorizații DSP",
    description: "Activăm cu toate autorizațiile necesare de la Direcția de Sănătate Publică.",
    icon: "ShieldCheck",
  },
  {
    title: "Mașini autorizate",
    description: "Dispunem de vehicule funerare autorizate, la standarde europene, pentru transport local și internațional.",
    icon: "Car",
  },
  {
    title: "Plata în rate",
    description: "Oferim posibilitatea de plată în rate, pentru a ușura povara financiară din aceste momente.",
    icon: "CreditCard",
  },
  {
    title: "Acceptăm ajutor de înmormântare",
    description: "Puteți achita serviciile direct prin ajutorul de înmormântare, fără costuri suplimentare.",
    icon: "HandHeart",
  },
  {
    title: "Colaborare cu toate bisericile",
    description: "Colaborăm cu toate bisericile și cimitirele din Constanța și împrejurimi.",
    icon: "Church",
  },
];

export const services = [
  {
    slug: "servicii-complete-inmormantare-constanta",
    title: "Servicii Complete de Înmormântare Constanța",
    shortTitle: "Servicii Complete Înmormântare",
    metaTitle: "Servicii Complete de Înmormântare Constanța – Casa Funerară Sfântul Andrei",
    metaDescription: "Servicii funerare complete în Constanța. Organizare înmormântare de la A la Z, NON-STOP 24/7. Experiență 10 ani. Sună acum: +40 786 135 139",
    icon: "Heart",
    intro: "Pierderea unei persoane dragi este una dintre cele mai dureroase experiențe din viață. În aceste momente de profundă tristețe, Casa Funerară Sfântul Andrei vă oferă sprijin complet și profesionist pentru organizarea ceremoniei de înmormântare în Constanța. Cu o experiență de peste 10 ani, echipa noastră se ocupă de fiecare detaliu, de la întocmirea actelor de deces până la organizarea completă a ceremoniei religioase și a parastasului. Ne angajăm să respectăm tradițiile și dorințele familiei, oferind servicii de cea mai înaltă calitate, cu empatie și discreție.",
    includes: [
      "Preluare decedat de la domiciliu, spital sau medicina legală",
      "Întocmirea completă a actelor de deces",
      "Îmbălsămare și pregătirea decedatului",
      "Sicriu la alegere din catalogul nostru",
      "Transport funerar cu mașini autorizate",
      "Cruci, lumânări și aranjamente florale",
      "Organizarea ceremoniei religioase",
      "Asistență completă la cimitir",
      "Parastas și pachete tradiționale la cerere",
    ],
    whyChoose: [
      "Preluăm întreaga responsabilitate a organizării",
      "Prețuri transparente, fără costuri ascunse",
      "Consiliere și sprijin emoțional pe parcursul întregului proces",
      "Colaborare cu toate bisericile și cimitirele din Constanța",
    ],
    faqs: [
      { q: "Cât costă o înmormântare completă în Constanța?", a: "Prețul variază în funcție de pachetul ales, tipul sicriului și serviciile suplimentare. Oferim pachete de la bugete accesibile la variante premium. Contactați-ne pentru o ofertă personalizată." },
      { q: "Cât durează organizarea unei înmormântări?", a: "De regulă, organizăm complet o înmormântare în 24-48 de ore. Suntem disponibili NON-STOP pentru situații urgente." },
      { q: "Puteți prelua decedatul de la spital?", a: "Da, preluăm decedatul de la orice locație din Constanța și împrejurimi – spital, domiciliu sau medicina legală." },
      { q: "Acceptați plata prin ajutor de înmormântare?", a: "Da, acceptăm plata directă prin ajutorul de înmormântare. Vă ajutăm și cu întocmirea dosarului necesar." },
    ],
  },
  {
    slug: "servicii-funerare-lumina",
    title: "Servicii Funerare Lumina – Organizare Completă",
    shortTitle: "Servicii Funerare Lumina",
    metaTitle: "Servicii Funerare Lumina – Casa Funerară Sfântul Andrei",
    metaDescription: "Servicii funerare complete în Comuna Lumina. Organizare înmormântare, transport funerar, acte de deces. NON-STOP. Tel: +40 786 135 139",
    icon: "MapPin",
    intro: "Casa Funerară Sfântul Andrei oferă servicii funerare complete în Comuna Lumina și localitățile învecinate. Sediul nostru din Str. Mare nr. 136 este deschis permanent, fiind pregătiți să vă oferim sprijin imediat în cele mai dificile momente. Echipa noastră din Lumina cunoaște comunitatea locală și colaborează strâns cu bisericile și cimitirele din zonă, asigurând că fiecare ceremonie se desfășoară cu respectul și demnitatea cuvenite.",
    includes: [
      "Preluare decedat din Comuna Lumina și împrejurimi",
      "Întocmire acte de deces la Primăria Lumina",
      "Sicrie, cruci și obiecte funerare",
      "Transport funerar autorizat",
      "Aranjamente florale și coroane",
      "Organizare ceremonie religioasă",
      "Parastas și pachete tradiționale",
      "Asistență completă la cimitir",
    ],
    whyChoose: [
      "Sediu propriu în Comuna Lumina",
      "Cunoașterea comunității și tradițiilor locale",
      "Colaborare cu toate bisericile din Lumina",
      "Răspuns rapid, NON-STOP",
    ],
    faqs: [
      { q: "Aveți sediu în Lumina?", a: "Da, sediul nostru din Lumina se află pe Str. Mare nr. 136. Suntem disponibili NON-STOP." },
      { q: "Puteți organiza înmormântarea în aceeași zi?", a: "În funcție de situație, putem organiza ceremonia în cel mai scurt timp posibil. Contactați-ne pentru detalii." },
      { q: "Ce zone acoperiți din Lumina?", a: "Acoperim Comuna Lumina și toate localitățile învecinate, inclusiv Oituz, Sibioara și zonele din proximitate." },
    ],
  },
  {
    slug: "organizare-inmormantare-completa",
    title: "Organizare Înmormântare Completă – De la A la Z",
    shortTitle: "Organizare Înmormântare",
    metaTitle: "Organizare Înmormântare Completă Constanța – Casa Funerară Sfântul Andrei",
    metaDescription: "Organizare înmormântare completă în Constanța. Ne ocupăm de tot: acte, sicriu, transport, ceremonie. NON-STOP 24/7. Tel: +40 786 135 139",
    icon: "ClipboardList",
    intro: "Organizarea unei înmormântări presupune o multitudine de detalii administrative, logistice și emoționale. Casa Funerară Sfântul Andrei preia întreaga responsabilitate, astfel încât familia să se poată concentra pe ceea ce contează cu adevărat – momentele de rămas bun și sprijinul reciproc. De la primele formalități birocratice până la ultimul detaliu al ceremoniei, echipa noastră vă ghidează cu profesionalism și compasiune pe parcursul întregului proces.",
    includes: [
      "Consiliere inițială și planificare ceremonie",
      "Întocmirea tuturor documentelor necesare",
      "Alegerea și personalizarea serviciilor",
      "Coordonarea cu biserica și cimitirul",
      "Transport și pregătirea decedatului",
      "Furnizarea tuturor materialelor funerare",
      "Organizarea parastasului",
      "Suport post-înmormântare",
    ],
    whyChoose: [
      "Serviciu all-inclusive, fără griji suplimentare",
      "Coordonare profesionistă a tuturor etapelor",
      "Flexibilitate în alegerea pachetelor",
      "Experiență vastă în organizare",
    ],
    faqs: [
      { q: "Ce trebuie să fac la decesul unei persoane apropiate?", a: "Sunați-ne imediat la +40 786 135 139. Vă ghidăm pas cu pas prin toate etapele necesare, de la constatarea medicală până la ceremonia de înmormântare." },
      { q: "Vă ocupați și de actele de deces?", a: "Da, ne ocupăm integral de întocmirea și depunerea tuturor actelor necesare la instituțiile competente." },
      { q: "Pot personaliza ceremonia?", a: "Absolut. Respectăm dorințele familiei și putem personaliza fiecare aspect al ceremoniei." },
    ],
  },
  {
    slug: "transport-funerar-local",
    title: "Transport Funerar Local în Constanța și Împrejurimi",
    shortTitle: "Transport Funerar Local",
    metaTitle: "Transport Funerar Local Constanța – Autorizat | Casa Funerară Sfântul Andrei",
    metaDescription: "Transport funerar local autorizat în Constanța. Mașini la standarde europene, disponibil NON-STOP 24/7. Sună: +40 786 135 139",
    icon: "Truck",
    intro: "Transportul funerar local necesită autorizații speciale și vehicule corespunzătoare. Casa Funerară Sfântul Andrei dispune de mașini funerare autorizate, echipate la standarde europene, pentru transportul decedaților în Constanța și localitățile din județul Constanța. Echipa noastră asigură preluarea de la orice locație – domiciliu, spital sau medicina legală – și transportul în condiții de maximă demnitate.",
    includes: [
      "Preluare de la domiciliu, spital sau IML",
      "Vehicule funerare autorizate și echipate",
      "Șoferi profesioniști și discreți",
      "Transport către biserică și cimitir",
      "Acoperire întregul județ Constanța",
      "Disponibilitate NON-STOP",
    ],
    whyChoose: [
      "Mașini la standarde europene",
      "Autorizații complete de transport",
      "Răspuns rapid în orice zonă a județului",
      "Discreție maximă",
    ],
    faqs: [
      { q: "Cât durează preluarea decedatului?", a: "Ajungem în cel mai scurt timp posibil, de regulă în 1-2 ore de la apel, în funcție de locație." },
      { q: "Transportați și în afara Constanței?", a: "Da, acoperim întreg județul Constanța. Pentru transport național sau internațional, avem servicii dedicate." },
      { q: "Aveți mașini autorizate?", a: "Da, toate vehiculele noastre sunt autorizate conform legislației în vigoare și echipate la standarde europene." },
    ],
  },
  {
    slug: "transport-funerar-national",
    title: "Transport Funerar Național – Din Constanța în Toată România",
    shortTitle: "Transport Funerar Național",
    metaTitle: "Transport Funerar Național din Constanța – Casa Funerară Sfântul Andrei",
    metaDescription: "Transport funerar național din Constanța în orice localitate din România. Mașini autorizate, documentație completă. Tel: +40 786 135 139",
    icon: "Route",
    intro: "Când familia decedatului se află în altă parte a țării, transportul funerar național devine o necesitate urgentă. Casa Funerară Sfântul Andrei asigură transportul decedaților din Constanța către orice localitate din România, în condiții de maximă siguranță și demnitate. Ne ocupăm de toate formalitățile, autorizațiile de transport și coordonarea cu autoritățile locale din destinație.",
    includes: [
      "Transport în orice localitate din România",
      "Vehicule autorizate pentru transport național",
      "Întocmirea autorizațiilor de transport",
      "Sicriu de transport special (zinc)",
      "Coordonare cu autoritățile din destinație",
      "Asigurare pe toată durata transportului",
    ],
    whyChoose: [
      "Experiență în trasee lungi",
      "Documentație completă și conformă",
      "Coordonare cu parteneri în toată țara",
      "Vehicule sigure și confortabile",
    ],
    faqs: [
      { q: "Cât durează transportul funerar național?", a: "Durata depinde de distanță. Asigurăm transportul în cel mai scurt timp, cu respectarea tuturor normelor legale." },
      { q: "Ce documente sunt necesare?", a: "Ne ocupăm noi de toate documentele necesare: certificat de deces, autorizație de transport și orice alte acte solicitate." },
      { q: "Trebuie sicriu special pentru transport?", a: "Da, pentru transport pe distanțe lungi se utilizează sicriu special. Vă punem la dispoziție toate variantele necesare." },
    ],
  },
  {
    slug: "transport-funerar-international",
    title: "Transport Funerar Internațional din Constanța – Rapid și Autorizat",
    shortTitle: "Transport Funerar Internațional",
    metaTitle: "Transport Funerar Internațional din Constanța – Rapid și Autorizat | Sfântul Andrei",
    metaDescription: "Transport funerar internațional din Constanța. Repatriere decedați, documentație consulară completă. NON-STOP. Tel: +40 786 135 139",
    icon: "Globe",
    intro: "Repatrierea sau expedierea unui decedat în/din afara granițelor necesită proceduri complexe, autorizații consulare și coordonare internațională. Casa Funerară Sfântul Andrei din Constanța oferă servicii de transport funerar internațional, gestionând întreaga documentație și logistică necesară. Cu experiență în repatrierea decedaților din și către numeroase țări europene, suntem pregătiți să vă oferim suportul necesar în aceste momente dificile.",
    includes: [
      "Repatriere decedați din/în străinătate",
      "Documentație consulară completă",
      "Sicriu de zinc conform normelor internaționale",
      "Îmbălsămare autorizată pentru transport",
      "Coordonare cu ambasade și consulate",
      "Transport aerian sau rutier",
      "Asistență juridică specializată",
    ],
    whyChoose: [
      "Experiență în transport internațional",
      "Cunoașterea legislației internaționale",
      "Rețea de parteneri în Europa",
      "Gestionare completă a documentației",
    ],
    faqs: [
      { q: "Ce țări acoperiți pentru transport internațional?", a: "Asigurăm transport funerar în și din majoritatea țărilor europene. Contactați-ne pentru detalii specifice despre destinația dorită." },
      { q: "Cât durează repatrierea unui decedat?", a: "Durata variază în funcție de țara de origine, de regulă între 3-7 zile lucrătoare, incluzând obținerea tuturor avizelor." },
      { q: "Ce documente sunt necesare pentru transport internațional?", a: "Sunt necesare: certificat de deces, pașaport mortuar, autorizație de transport internațional, certificat de îmbălsămare. Ne ocupăm noi de toate." },
      { q: "Se poate face transport pe cale aeriană?", a: "Da, organizăm transport atât rutier cât și aerian, în funcție de destinație și urgență." },
    ],
  },
  {
    slug: "intocmire-acte-deces-documentatie",
    title: "Întocmire Acte de Deces și Documentație Completă",
    shortTitle: "Acte de Deces",
    metaTitle: "Întocmire Acte de Deces Constanța – Documentație Completă | Sfântul Andrei",
    metaDescription: "Servicii de întocmire acte de deces și documentație funerară completă în Constanța. Ne ocupăm de tot. NON-STOP. Tel: +40 786 135 139",
    icon: "FileCheck",
    intro: "În momentele de doliu, formalitățile birocratice pot părea copleșitoare. Casa Funerară Sfântul Andrei preia integral sarcina întocmirii documentelor necesare, de la obținerea certificatului constatator al decesului până la actele finale de la primărie. Echipa noastră cunoaște toate procedurile și instituțiile din Constanța, asigurând un proces rapid și fără complicații.",
    includes: [
      "Certificat constatator al decesului",
      "Certificat de deces de la primărie",
      "Adeverință de înhumare",
      "Autorizație de transport (dacă este cazul)",
      "Documente pentru ajutor de înmormântare",
      "Acte pentru repatriere (dacă este cazul)",
      "Depunere și ridicare acte de la instituții",
    ],
    whyChoose: [
      "Cunoașterea perfectă a procedurilor locale",
      "Rapiditate în obținerea documentelor",
      "Zero bătaie de cap pentru familie",
      "Experiență cu toate instituțiile din Constanța",
    ],
    faqs: [
      { q: "Ce acte sunt necesare la decesul unei persoane?", a: "Principalele acte necesare sunt: certificat constatator, certificat de deces, adeverință de înhumare. Ne ocupăm noi de toate." },
      { q: "Cât durează obținerea actelor de deces?", a: "De regulă, finalizăm toate actele în 24 de ore. Colaborăm direct cu toate instituțiile din Constanța." },
      { q: "Trebuie să merg personal la primărie?", a: "Nu, ne ocupăm noi de depunerea și ridicarea tuturor documentelor de la primărie și alte instituții." },
    ],
  },
  {
    slug: "imbalsamare-toaletare-decedat",
    title: "Îmbălsămare și Toaletare Decedat – Servicii Profesionale",
    shortTitle: "Îmbălsămare și Toaletare",
    metaTitle: "Îmbălsămare și Toaletare Decedat Constanța | Casa Funerară Sfântul Andrei",
    metaDescription: "Servicii profesionale de îmbălsămare și toaletare decedat în Constanța. Pregătire pentru ceremonie cu respect și demnitate. Tel: +40 786 135 139",
    icon: "Sparkles",
    intro: "Pregătirea decedatului pentru ceremonia de rămas bun este un act de profund respect. Casa Funerară Sfântul Andrei oferă servicii profesionale de îmbălsămare și toaletare, realizate de specialiști cu experiență. Fiecare etapă este efectuată cu cea mai mare grijă, asigurând că persoana dragă arată demn și liniștit în momentele de adio.",
    includes: [
      "Îmbălsămare profesională autorizată",
      "Toaletare și pregătire estetică",
      "Îmbrăcare în hainele alese de familie",
      "Pregătire pentru priveghi și ceremonie",
      "Servicii speciale pentru transport internațional",
      "Reconstituire facială (când este necesar)",
    ],
    whyChoose: [
      "Specialiști cu experiență",
      "Respectarea demnității decedatului",
      "Autorizații complete",
      "Discreție absolută",
    ],
    faqs: [
      { q: "Este obligatorie îmbălsămarea?", a: "Nu este obligatorie în toate cazurile, dar este recomandată, mai ales dacă ceremonia are loc la câteva zile după deces sau dacă se face transport pe distanțe lungi." },
      { q: "Cât durează procesul de pregătire?", a: "Pregătirea completă durează de regulă câteva ore, în funcție de serviciile solicitate." },
      { q: "Pot aduce haine specifice pentru decedat?", a: "Da, respectăm întotdeauna dorințele familiei privind îmbrăcămintea și aspectul decedatului." },
    ],
  },
  {
    slug: "servicii-incinerare",
    title: "Servicii de Incinerare în Constanța – Alternativă Demnă",
    shortTitle: "Servicii de Incinerare",
    metaTitle: "Servicii de Incinerare Constanța | Casa Funerară Sfântul Andrei",
    metaDescription: "Servicii de incinerare în Constanța. Organizare completă, transport la crematoriu, asistență documentație. Tel: +40 786 135 139",
    icon: "Flame",
    intro: "Incinerarea reprezintă o alternativă demnă la înmormântarea tradițională, aleasă din ce în ce mai des de familiile din Constanța. Casa Funerară Sfântul Andrei vă oferă asistență completă în organizarea serviciului de incinerare, de la pregătirea documentelor necesare până la transportul la crematoriu și predarea urnei cu cenușa.",
    includes: [
      "Consiliere și planificare ceremonie",
      "Întocmirea documentelor pentru incinerare",
      "Transport la crematoriu",
      "Sicriu de incinerare",
      "Ceremonie de rămas bun",
      "Urnă funerară la alegere",
      "Predarea cenușii familiei",
    ],
    whyChoose: [
      "Experiență în servicii de incinerare",
      "Respectul tradițiilor familiei",
      "Varietate de urne funerare",
      "Asistență completă",
    ],
    faqs: [
      { q: "Unde se face incinerarea?", a: "Colaborăm cu crematoriile autorizate din regiune. Asigurăm transportul și toate formalitățile." },
      { q: "Se poate organiza și o ceremonie religioasă?", a: "Da, putem organiza o ceremonie religioasă înainte de incinerare, conform dorințelor familiei." },
      { q: "Cât durează procesul de incinerare?", a: "Întregul proces, de la organizare la predarea urnei, durează de regulă 3-5 zile." },
    ],
  },
  {
    slug: "aranjamente-florale-funerare",
    title: "Aranjamente Florale Funerare – Coroane și Buchete",
    shortTitle: "Aranjamente Florale",
    metaTitle: "Aranjamente Florale Funerare Constanța – Coroane, Buchete | Sfântul Andrei",
    metaDescription: "Aranjamente florale funerare în Constanța: coroane, buchete, jerbe. Livrare directă la ceremonie. Sună: +40 786 135 139",
    icon: "Flower2",
    intro: "Florile reprezintă un simbol al respectului, iubirii și al amintirii celor dragi. Casa Funerară Sfântul Andrei vă pune la dispoziție o gamă variată de aranjamente florale funerare – coroane, buchete, jerbe și aranjamente personalizate. Fiecare compoziție florală este realizată cu grijă și rafinament, pentru a onora memoria celui plecat.",
    includes: [
      "Coroane funerare rotunde și ovale",
      "Jerbe și buchete de condoleanțe",
      "Aranjamente pentru sicriu",
      "Aranjamente personalizate",
      "Panglici cu mesaje dedicate",
      "Livrare directă la ceremonie",
    ],
    whyChoose: [
      "Flori proaspete, de calitate",
      "Aranjamente personalizate",
      "Livrare rapidă",
      "Prețuri pentru orice buget",
    ],
    faqs: [
      { q: "Pot comanda aranjamente personalizate?", a: "Da, realizăm aranjamente florale personalizate conform dorințelor dumneavoastră." },
      { q: "Livrați și la domiciliu?", a: "Da, livrăm aranjamentele direct la locația ceremoniei, la biserică sau la domiciliu." },
      { q: "Ce tipuri de flori sunt potrivite pentru funeralii?", a: "Cele mai utilizate sunt crizantemele, trandafirii, crinii și garoafele, dar putem realiza aranjamente cu orice tip de flori." },
    ],
  },
  {
    slug: "parastas-pomeniri",
    title: "Parastas și Pomeniri – Organizare Completă",
    shortTitle: "Parastas și Pomeniri",
    metaTitle: "Parastas și Pomeniri Constanța – Organizare Completă | Sfântul Andrei",
    metaDescription: "Organizare parastas și pomeniri în Constanța. Pachete complete, colivă, prosoape. Respect pentru tradiții. Tel: +40 786 135 139",
    icon: "Candle",
    intro: "Parastasul și pomenirile sunt tradiții importante în cultura ortodoxă românească, prin care onorăm memoria celor trecuți în neființă. Casa Funerară Sfântul Andrei oferă sprijin complet în organizarea parastaselor la toate termenele tradiționale – 3, 9, 40 de zile, 6 luni, 1 an și în fiecare an ulterior. Ne asigurăm că fiecare tradiție este respectată cu sfințenie.",
    includes: [
      "Pachete de parastas complete",
      "Colivă pregătită tradițional",
      "Prosoape și batiste de pomenire",
      "Lumânări și tămâie",
      "Coordonare cu biserica",
      "Pachete de pomenire personalizate",
    ],
    whyChoose: [
      "Cunoașterea profundă a tradițiilor",
      "Produse de calitate",
      "Pachete accesibile",
      "Organizare fără griji",
    ],
    faqs: [
      { q: "La ce termene se face parastas?", a: "Conform tradiției ortodoxe: la 3 zile, 9 zile, 40 de zile, 6 luni, 1 an și apoi anual." },
      { q: "Ce include un pachet de parastas?", a: "Include de regulă colivă, colaci, lumânări, prosoape, batiste și alte elemente tradiționale." },
      { q: "Puteți organiza parastas și la domiciliu?", a: "Da, organizăm parastas atât la biserică, cât și la domiciliu sau la restaurant, conform preferințelor familiei." },
    ],
  },
  {
    slug: "coliva-pachete-traditionale",
    title: "Colivă și Pachete Tradiționale de Pomenire",
    shortTitle: "Colivă și Pachete",
    metaTitle: "Colivă și Pachete Tradiționale Constanța | Casa Funerară Sfântul Andrei",
    metaDescription: "Colivă tradițională și pachete de pomenire în Constanța. Prosoape, batiste, lumânări. Tradiție respectată. Tel: +40 786 135 139",
    icon: "Package",
    intro: "Coliva și pachetele tradiționale de pomenire ocupă un loc central în ritualul funerar ortodox. Casa Funerară Sfântul Andrei oferă colivă pregătită tradițional și pachete complete de pomenire, respectând cu sfințenie obiceiurile moștenite din bătrâni. Fiecare pachet este pregătit cu grijă și conține toate elementele necesare pentru onorarea memoriei celui plecat.",
    includes: [
      "Colivă tradițională (mai multe mărimi)",
      "Colaci de pomenire",
      "Prosoape și batiste personalizate",
      "Lumânări de parastas",
      "Pachete individuale de pomană",
      "Fructe și dulciuri tradiționale",
    ],
    whyChoose: [
      "Rețete tradiționale respectate",
      "Ingrediente de calitate",
      "Pachete pentru orice buget",
      "Livrare la locația cermoniei",
    ],
    faqs: [
      { q: "Din ce este făcută coliva?", a: "Coliva se prepară tradițional din grâu fiert, zahăr, nucă, cacao și alte ingrediente, conform rețetelor tradiționale." },
      { q: "Puteți pregăti coliva fără gluten sau alte restricții?", a: "Da, putem adapta rețeta în funcție de cerințele familiei. Contactați-ne pentru detalii." },
      { q: "Cu cât timp înainte trebuie să comand?", a: "Recomandăm comanda cu cel puțin 24 de ore înainte, dar în cazuri urgente, facem tot posibilul să vă ajutăm." },
    ],
  },
  {
    slug: "consiliere-ajutor-inmormantare",
    title: "Consiliere Ajutor de Înmormântare – Ghid Complet",
    shortTitle: "Consiliere Ajutor Înmormântare",
    metaTitle: "Consiliere Ajutor de Înmormântare 2026 Constanța | Sfântul Andrei",
    metaDescription: "Consiliere gratuită pentru obținerea ajutorului de înmormântare 2026. Vă ghidăm cu actele necesare. Sună: +40 786 135 139",
    icon: "HelpCircle",
    intro: "Obținerea ajutorului de înmormântare poate fi un proces birocratic dificil, mai ales în momente de doliu. Casa Funerară Sfântul Andrei oferă consiliere gratuită și asistență completă în pregătirea dosarului pentru ajutorul de înmormântare. Vă ghidăm pas cu pas prin toate etapele, asigurându-ne că beneficiați de drepturile la care sunteți îndreptățit.",
    includes: [
      "Consiliere gratuită privind eligibilitatea",
      "Asistență în completarea dosarului",
      "Informații despre actele necesare",
      "Depunerea dosarului la instituțiile competente",
      "Posibilitatea de plată directă prin ajutor",
      "Urmărirea stadiului dosarului",
    ],
    whyChoose: [
      "Consiliere gratuită",
      "Experiență cu toate tipurile de ajutor",
      "Acceptăm plata directă prin ajutor",
      "Rapiditate în procesare",
    ],
    faqs: [
      { q: "Cine beneficiază de ajutor de înmormântare?", a: "Ajutorul de înmormântare se acordă familiei sau persoanei care suportă cheltuielile de înmormântare, în funcție de statutul asiguratului decedat." },
      { q: "Cât este ajutorul de înmormântare în 2026?", a: "Valoarea ajutorului variază anual. Contactați-ne pentru informații actualizate privind sumele valabile." },
      { q: "Pot plăti serviciile direct din ajutor?", a: "Da, acceptăm plata serviciilor funerare direct din ajutorul de înmormântare, fără costuri suplimentare." },
    ],
  },
  {
    slug: "servicii-funerare-non-stop",
    title: "Servicii Funerare NON-STOP 24/7 în Constanța",
    shortTitle: "Servicii NON-STOP 24/7",
    metaTitle: "Servicii Funerare NON-STOP 24/7 Constanța | Casa Funerară Sfântul Andrei",
    metaDescription: "Servicii funerare disponibile NON-STOP, 24 ore din 24, 7 zile din 7 în Constanța. Răspuns imediat. Sună oricând: +40 786 135 139",
    icon: "Clock",
    intro: "Pierderea unei persoane dragi nu ține cont de orar. De aceea, Casa Funerară Sfântul Andrei este disponibilă NON-STOP, 24 de ore din 24, 7 zile din 7, inclusiv în zilele de sărbătoare. Indiferent de ora la care aveți nevoie de sprijin, echipa noastră este pregătită să vă răspundă imediat și să înceapă organizarea tuturor detaliilor necesare.",
    includes: [
      "Răspuns telefonic NON-STOP",
      "Preluare decedat la orice oră",
      "Consiliere imediată",
      "Începerea formalităților imediat",
      "Transport funerar non-stop",
      "Permanență la ambele sedii",
    ],
    whyChoose: [
      "Disponibilitate absolută, fără excepții",
      "Echipă de permanență 24/7",
      "Timp de răspuns minim",
      "Profesionalism la orice oră",
    ],
    faqs: [
      { q: "Puteți prelua decedatul noaptea?", a: "Da, echipa noastră este disponibilă NON-STOP. Preluăm decedatul la orice oră din zi sau noapte." },
      { q: "Funcționați și în zilele de sărbătoare?", a: "Da, suntem disponibili 365 de zile pe an, inclusiv în toate zilele de sărbătoare." },
      { q: "Cât de repede puteți ajunge?", a: "De regulă, ajungem în 30-60 de minute în Constanța și împrejurimi, în funcție de locație." },
    ],
  },
];

export const products = {
  sicrie: [
    { name: "Sicriu Lemn Simplu", category: "Sicrie Lemn Simplu", description: "Sicrie din lemn de brad, finisaje discrete, ideale pentru ceremonii tradiționale.", priceRange: "Preț accesibil" },
    { name: "Sicriu Lemn Masiv", category: "Sicrie Lemn Masiv", description: "Sicrie din lemn masiv de stejar sau nuc, sculptate cu detalii elegante.", priceRange: "Preț mediu" },
    { name: "Sicriu Lux", category: "Sicrie Lux", description: "Sicrie premium din lemn masiv, captonaj de mătase, feronerie aurită.", priceRange: "Preț premium" },
  ],
  produse: [
    { name: "Cruci Funerare", description: "Cruci din lemn sau metal, diverse dimensiuni și modele." },
    { name: "Lumânări", description: "Lumânări de parastas și ceremoniale, în diverse mărimi." },
    { name: "Coroane Funerare", description: "Coroane din flori naturale sau artificiale, personalizate." },
    { name: "Colivă", description: "Colivă tradițională, pregătită după rețete autentice." },
    { name: "Prosoape de Pomenire", description: "Prosoape personalizate pentru ritualul de pomenire." },
    { name: "Batiste", description: "Batiste tradiționale pentru ceremonii și parastas." },
    { name: "Pachete Tradiționale", description: "Pachete complete cu toate elementele necesare pentru parastas." },
  ],
};

export const funeralAid = {
  title: "Ajutor de Înmormântare 2026 – Ghid Complet",
  metaTitle: "Ajutor de Înmormântare 2026 – Ghid Complet | Casa Funerară Sfântul Andrei",
  metaDescription: "Ghid complet ajutor de înmormântare 2026. Cine beneficiază, acte necesare, valoare, procedură. Consiliere gratuită. Tel: +40 786 135 139",
  intro: "Ajutorul de înmormântare este un drept legal acordat familiei celui decedat sau persoanei care suportă cheltuielile funerare. Casa Funerară Sfântul Andrei vă oferă informații complete și actualizate despre ajutorul de înmormântare pentru anul 2026, precum și consiliere gratuită pentru obținerea acestuia.",
  beneficiari: [
    "Soțul/soția supraviețuitoare",
    "Copiii, părinții sau rudele decedatului",
    "Persoana care dovedește că a suportat cheltuielile de înmormântare",
    "Beneficiarii sunt stabiliți conform Legii nr. 416/2001",
  ],
  acteNecesare: [
    "Certificatul de deces (original și copie)",
    "Actul de identitate al solicitantului",
    "Acte de stare civilă care dovedesc relația cu decedatul",
    "Dovada suportării cheltuielilor de înmormântare (facturi)",
    "Adeverință de la ultimul loc de muncă al decedatului (dacă era angajat)",
    "Cuponul de pensie (dacă decedatul era pensionar)",
    "Cerere tip completată",
  ],
  valoare: "Valoarea ajutorului de înmormântare este stabilită anual prin lege. Pentru 2026, vă recomandăm să ne contactați pentru suma exactă actualizată.",
  procedura: [
    "Contactați Casa Funerară Sfântul Andrei pentru consiliere gratuită",
    "Pregătim împreună dosarul cu actele necesare",
    "Depunem dosarul la Casa de Pensii sau la Primărie",
    "Urmărim procesarea și vă informăm despre stadiul dosarului",
    "Puteți achita serviciile noastre direct din ajutorul primit",
  ],
  faqs: [
    { q: "Cine acordă ajutorul de înmormântare?", a: "Ajutorul este acordat de Casa de Pensii (pentru pensionari), angajator (pentru salariați), sau Primărie (pentru persoanele fără venituri)." },
    { q: "În cât timp se primește ajutorul?", a: "De regulă, ajutorul se acordă în 24-30 de zile de la depunerea dosarului complet." },
    { q: "Pot plăti înmormântarea direct din ajutor?", a: "Da, Casa Funerară Sfântul Andrei acceptă plata directă prin ajutorul de înmormântare." },
    { q: "Este ajutorul de înmormântare impozabil?", a: "Nu, ajutorul de înmormântare este scutit de impozit." },
    { q: "Ce se întâmplă dacă decedatul nu avea asigurare?", a: "Chiar și în acest caz, se poate solicita ajutor de la Primărie. Vă consiliem gratuit." },
  ],
};

export const blogPosts = [
  {
    slug: "ce-trebuie-sa-faci-in-caz-de-deces-constanta",
    title: "Ce trebuie să faci în caz de deces în Constanța – Ghid complet pentru familii",
    metaTitle: "Ce trebuie să faci în caz de deces în Constanța – Ghid complet 2025",
    metaDescription: "Ghid complet pentru caz de deces în Constanța: acte necesare, preluare decedat, transport funerar, servicii funerare NON-STOP.",
    excerpt: "Ghid complet pentru caz de deces în Constanța: acte necesare, preluare decedat, transport funerar, servicii funerare NON-STOP.",
    image: "/images/blog-candles.jpg",
    date: "15 Februarie 2025",
    category: "Ghiduri",
    readTime: "12 min",
    content: [
      { type: "paragraph", text: "Pierderea unei persoane dragi este unul dintre cele mai dificile momente din viață. În astfel de clipe, durerea și șocul emoțional pot face ca lucrurile administrative să pară copleșitoare. Dacă te afli în Constanța, Lumina sau în localitățile din apropiere, este important să știi exact care sunt pașii legali și organizatorici care trebuie urmați." },
      { type: "paragraph", text: "Acest ghid complet îți explică, pas cu pas, ce trebuie să faci în caz de deces și cum te poate ajuta o casă funerară din Constanța să preia responsabilitățile necesare." },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei oferă servicii funerare complete în Constanța, fiind disponibilă NON-STOP 24/7 pentru intervenții rapide și sprijin total." },
      { type: "heading", text: "Primul pas: Constatarea decesului" },
      { type: "subheading", text: "Deces la domiciliu" },
      { type: "paragraph", text: "În cazul în care decesul are loc acasă, primul lucru pe care trebuie să îl faci este să contactezi:" },
      { type: "list", items: ["Medicul de familie (dacă decesul era așteptat)", "Serviciul de urgență 112 (în situații neprevăzute)"] },
      { type: "paragraph", text: "Medicul va constata oficial decesul și va elibera certificatul constatator de deces, document esențial pentru următoarele etape." },
      { type: "subheading", text: "Deces în spital" },
      { type: "paragraph", text: "Dacă decesul are loc într-o unitate medicală, personalul spitalului se ocupă de constatare și de eliberarea documentelor necesare." },
      { type: "subheading", text: "Deces care necesită IML" },
      { type: "paragraph", text: "În anumite situații (accidente, cauze neclare), cazul este preluat de Institutul de Medicină Legală (IML). Procedurile pot dura mai mult, iar transportul funerar trebuie realizat de o firmă autorizată." },
      { type: "heading", text: "Al doilea pas: Contactarea unei case funerare în Constanța" },
      { type: "paragraph", text: "După constatarea decesului, următorul pas este organizarea preluării persoanei decedate." },
      { type: "paragraph", text: "Este recomandat să contactezi o firmă de servicii funerare NON-STOP în Constanța, care poate interveni rapid și se poate ocupa de toate procedurile." },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei oferă:" },
      { type: "list", items: ["Preluare decedat de la domiciliu", "Preluare de la spital", "Preluare de la IML", "Preluare de la azil de bătrâni", "Transport funerar autorizat în Constanța și împrejurimi", "Manipulare și așezare în sicriu", "Capac frigorific"] },
      { type: "paragraph", text: "Disponibilitatea NON-STOP este esențială, deoarece astfel de situații nu pot fi programate." },
      { type: "cta", text: "Telefon NON-STOP: 0786 135 139" },
      { type: "heading", text: "Actele necesare pentru certificatul de deces" },
      { type: "paragraph", text: "Pentru eliberarea certificatului de deces de la Starea Civilă sunt necesare următoarele documente:" },
      { type: "list", items: ["Certificatul constatator de deces", "Actul de identitate al persoanei decedate", "Certificatul de naștere", "Certificatul de căsătorie (dacă este cazul)", "Actul de identitate al persoanei care declară decesul"] },
      { type: "paragraph", text: "O casă funerară din Constanța cu experiență îți poate oferi consultanță completă pentru aceste acte, astfel încât să eviți drumuri inutile și întârzieri." },
      { type: "heading", text: "Organizarea înmormântării în Constanța" },
      { type: "paragraph", text: "După obținerea certificatului de deces, începe organizarea propriu-zisă a ceremoniei." },
      { type: "subheading", text: "Alegerea sicriului și a produselor funerare" },
      { type: "paragraph", text: "O firmă de servicii funerare complete în Constanța oferă:" },
      { type: "list", items: ["Sicrie diverse modele", "Lenjerie funerară", "Cruci", "Accesorii funerare", "Lumânări", "Coroane și aranjamente florale"] },
      { type: "subheading", text: "Îmbălsămare și pregătire" },
      { type: "paragraph", text: "În funcție de situație, poate fi necesară îmbălsămarea. Aceasta este realizată de personal autorizat, conform normelor sanitare. Se pot oferi și servicii de:" },
      { type: "list", items: ["Cosmetizare", "Aranjare decedat", "Îmbrăcare"] },
      { type: "subheading", text: "Organizarea priveghiului" },
      { type: "paragraph", text: "Priveghiul poate avea loc:" },
      { type: "list", items: ["La capelă", "La domiciliu", "La biserică"] },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei oferă sprijin în organizarea completă a priveghiului." },
      { type: "subheading", text: "Stabilirea datei și colaborarea cu biserica" },
      { type: "paragraph", text: "Pentru familiile care respectă tradiția ortodoxă, este importantă:" },
      { type: "list", items: ["Contactarea preotului", "Stabilirea datei slujbei", "Rezervarea capelei", "Programarea la cimitir"] },
      { type: "paragraph", text: "O casă funerară din Constanța cu experiență cunoaște procedurile și poate facilita toate aceste etape." },
      { type: "subheading", text: "Pomeni și parastase" },
      { type: "paragraph", text: "În tradiția ortodoxă, pomenile au un rol important. Serviciile funerare complete pot include:" },
      { type: "list", items: ["Colivă", "Colaci", "Pachete pentru pomeni", "Organizarea mesei de pomenire (în colaborare cu locații)"] },
      { type: "heading", text: "De ce este important să alegi o casă funerară completă în Constanța?" },
      { type: "paragraph", text: "Atunci când alegi o firmă de servicii funerare în Constanța, este important să te asiguri că:" },
      { type: "list", items: ["Oferă intervenție NON-STOP", "Este autorizată pentru transport funerar", "Oferă consultanță pentru acte", "Are experiență", "Este transparentă privind costurile"] },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei oferă servicii funerare complete în Constanța, Lumina și împrejurimi, ocupându-se de absolut toate detaliile." },
      { type: "heading", text: "Sprijin în momente dificile" },
      { type: "paragraph", text: "Dincolo de proceduri și acte, cel mai important lucru este sprijinul uman. O echipă profesionistă și empatică poate face diferența între un proces stresant și unul gestionat cu calm și respect." },
      { type: "paragraph", text: "Noi credem că fiecare familie merită:" },
      { type: "list", items: ["Demnitate", "Discreție", "Organizare corectă", "Sprijin real"] },
      { type: "heading", text: "Concluzie" },
      { type: "paragraph", text: "Dacă te confrunți cu un deces în Constanța sau în împrejurimi, nu trebuie să gestionezi singur toate aceste etape." },
      { type: "paragraph", text: "Suntem disponibili NON-STOP 24/7 pentru:" },
      { type: "list", items: ["Preluare decedat", "Transport funerar Constanța", "Organizare înmormântare", "Acte și formalități", "Pachete funerare complete"] },
      { type: "cta", text: "Sună acum la 0786 135 139" },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei – servicii funerare complete în Constanța, oferite cu respect și profesionalism." },
    ],
  },
  {
    slug: "servicii-funerare-constanta-ghid-complet",
    title: "Servicii funerare Constanța – Ce includ și cum alegi corect o casă funerară",
    metaTitle: "Servicii funerare Constanța – Ghid complet 2025 | Casă funerară NON-STOP",
    metaDescription: "Descoperă ce includ serviciile funerare în Constanța. Preluare decedat, transport funerar, acte, pachete complete. Disponibilitate NON-STOP 24/7.",
    excerpt: "Descoperă ce includ serviciile funerare în Constanța. Preluare decedat, transport funerar, acte, pachete complete. Disponibilitate NON-STOP 24/7.",
    image: "/images/showroom-coffins-wreaths.jpg",
    date: "20 Februarie 2025",
    category: "Servicii",
    readTime: "14 min",
    content: [
      { type: "paragraph", text: "Atunci când pierzi o persoană dragă, ultimul lucru pe care ți-l dorești este să fii copleșit de proceduri, acte și organizare. În astfel de momente, alegerea unei firme de servicii funerare în Constanța devine una dintre cele mai importante decizii." },
      { type: "paragraph", text: "Dar ce înseamnă, concret, servicii funerare complete? Ce ar trebui să includă? Cum alegi corect o casă funerară în Constanța care să ofere profesionalism, respect și sprijin real?" },
      { type: "paragraph", text: "În acest ghid detaliat vei găsi toate informațiile necesare pentru a lua o decizie informată." },
      { type: "heading", text: "Ce înseamnă servicii funerare complete în Constanța?" },
      { type: "paragraph", text: "Serviciile funerare complete presupun preluarea tuturor responsabilităților legate de organizarea unei înmormântări, de la momentul decesului până la finalizarea ceremoniei și a formalităților." },
      { type: "paragraph", text: "O casă funerară din Constanța ar trebui să ofere:" },
      { type: "list", items: ["Preluare decedat de la domiciliu, spital, IML sau azil", "Transport funerar autorizat", "Manipulare și pregătire decedat", "Îmbălsămare (acolo unde este necesar)", "Aranjare și cosmetizare", "Capac frigorific", "Organizarea ceremoniei", "Produse funerare (sicrie, cruci, accesorii)", "Coroane și aranjamente florale", "Colivă și colaci pentru pomeni", "Consultanță pentru acte și formalități"] },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei oferă servicii funerare complete în Constanța, Lumina și împrejurimi, fiind disponibilă NON-STOP 24/7." },
      { type: "heading", text: "Preluare decedat și transport funerar în Constanța" },
      { type: "paragraph", text: "Unul dintre cele mai urgente servicii este preluarea persoanei decedate." },
      { type: "paragraph", text: "O firmă profesionistă de servicii funerare în Constanța trebuie să asigure:" },
      { type: "list", items: ["Intervenție rapidă", "Mașini funerare autorizate", "Personal instruit pentru manipulare", "Respectarea normelor sanitare"] },
      { type: "paragraph", text: "Transportul funerar în Constanța trebuie realizat legal, cu autovehicule special echipate. Este important să alegi o firmă autorizată, pentru a evita problemele legale sau întârzierile." },
      { type: "paragraph", text: "Disponibilitatea NON-STOP este esențială, deoarece astfel de situații pot apărea în orice moment." },
      { type: "heading", text: "Pregătirea persoanei decedate" },
      { type: "paragraph", text: "După preluare, urmează etapa de pregătire. Aceasta poate include:" },
      { type: "list", items: ["Toaletare și igienizare", "Îmbrăcare", "Aranjare în sicriu", "Cosmetizare", "Îmbălsămare"] },
      { type: "paragraph", text: "Îmbălsămarea este necesară în anumite situații, mai ales când ceremonia nu are loc imediat. Aceasta trebuie realizată de personal autorizat." },
      { type: "paragraph", text: "O casă funerară cu experiență în Constanța va explica clar când este necesară și ce implică procedura." },
      { type: "heading", text: "Produse funerare – Ce opțiuni există?" },
      { type: "paragraph", text: "Un alt element important în cadrul serviciilor funerare în Constanța îl reprezintă produsele funerare. Acestea includ:" },
      { type: "list", items: ["Sicrie (diverse modele și finisaje)", "Lenjerie funerară", "Cruci", "Plăcuțe personalizate", "Urne (în caz de incinerare)", "Lumânări", "Accesorii"] },
      { type: "paragraph", text: "Este important ca firma să ofere mai multe opțiuni, adaptate diferitelor bugete." },
      { type: "heading", text: "Organizarea ceremoniei funerare" },
      { type: "paragraph", text: "O casă funerară din Constanța cu servicii complete trebuie să ajute la:" },
      { type: "list", items: ["Stabilirea datei înmormântării", "Colaborarea cu biserica", "Rezervarea capelei", "Programarea la cimitir", "Coordonarea întregii ceremonii"] },
      { type: "paragraph", text: "Pentru familiile care respectă tradiția ortodoxă, organizarea corectă a slujbei este esențială. Totodată, este important ca firma să fie flexibilă și pentru alte confesiuni." },
      { type: "heading", text: "Pomeni și parastase" },
      { type: "paragraph", text: "În cultura românească, pomenile au un rol important. Serviciile funerare complete în Constanța pot include:" },
      { type: "list", items: ["Colivă", "Colaci", "Pachete pentru pomeni", "Organizarea mesei de pomenire"] },
      { type: "paragraph", text: "Acest tip de suport reduce semnificativ stresul familiei." },
      { type: "heading", text: "Acte și formalități – O etapă esențială" },
      { type: "paragraph", text: "Procedurile administrative pot fi complicate. Pentru eliberarea certificatului de deces sunt necesare documente specifice, iar termenele trebuie respectate." },
      { type: "paragraph", text: "O casă funerară cu experiență în Constanța oferă:" },
      { type: "list", items: ["Consultanță completă", "Ghidare pas cu pas", "Sprijin în obținerea documentelor"] },
      { type: "paragraph", text: "Acest serviciu este extrem de valoros în momentele de vulnerabilitate." },
      { type: "heading", text: "Cum alegi corect o casă funerară în Constanța?" },
      { type: "paragraph", text: "Iată câteva criterii esențiale:" },
      { type: "subheading", text: "1. Disponibilitate NON-STOP" },
      { type: "paragraph", text: "Intervenția rapidă este crucială." },
      { type: "subheading", text: "2. Servicii complete" },
      { type: "paragraph", text: "Este mai simplu să lucrezi cu o firmă care oferă totul într-un singur loc." },
      { type: "subheading", text: "3. Autorizări legale" },
      { type: "paragraph", text: "Transport funerar autorizat și respectarea normelor sanitare." },
      { type: "subheading", text: "4. Transparență" },
      { type: "paragraph", text: "Prețuri clare, fără costuri ascunse." },
      { type: "subheading", text: "5. Experiență și empatie" },
      { type: "paragraph", text: "Profesionalism combinat cu abordare umană." },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei respectă toate aceste criterii, oferind servicii funerare complete în Constanța și împrejurimi." },
      { type: "heading", text: "De ce este importantă alegerea unei firme locale?" },
      { type: "paragraph", text: "Alegerea unei case funerare din Constanța are avantaje clare:" },
      { type: "list", items: ["Cunoaște procedurile locale", "Colaborează cu bisericile și cimitirele din zonă", "Poate interveni rapid", "Oferă sprijin personalizat"] },
      { type: "paragraph", text: "O firmă locală înțelege specificul comunității." },
      { type: "heading", text: "Costurile serviciilor funerare în Constanța" },
      { type: "paragraph", text: "Prețul serviciilor funerare diferă în funcție de:" },
      { type: "list", items: ["Tipul sicriului", "Necesitatea îmbălsămării", "Numărul serviciilor incluse", "Produsele suplimentare"] },
      { type: "paragraph", text: "Este recomandat să alegi o firmă care oferă pachete funerare personalizate și explică transparent ce include fiecare opțiune." },
      { type: "heading", text: "Sprijin real în momente dificile" },
      { type: "paragraph", text: "Dincolo de servicii și organizare, cel mai important aspect este sprijinul uman. O echipă profesionistă oferă:" },
      { type: "list", items: ["Calm", "Răbdare", "Discreție", "Respect"] },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei oferă servicii funerare NON-STOP în Constanța, fiind alături de familii în cele mai dificile momente." },
      { type: "heading", text: "Concluzie" },
      { type: "paragraph", text: "Alegerea unei firme de servicii funerare în Constanța este o decizie importantă, care influențează modul în care va fi organizată ceremonia și cât de ușor va trece familia prin acest proces." },
      { type: "paragraph", text: "Dacă ai nevoie de:" },
      { type: "list", items: ["Preluare decedat", "Transport funerar Constanța", "Organizare înmormântare", "Acte și formalități", "Pachete funerare complete"] },
      { type: "paragraph", text: "Suntem disponibili NON-STOP 24/7." },
      { type: "cta", text: "Sună acum la 0786 135 139" },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei – servicii funerare complete în Constanța, oferite cu respect și profesionalism." },
    ],
  },
  {
    slug: "transport-funerar-constanta-servicii-autorizate",
    title: "Transport funerar Constanța – Tot ce trebuie să știi despre preluare și transport în siguranță",
    metaTitle: "Transport funerar Constanța – Servicii autorizate NON-STOP 24/7",
    metaDescription: "Transport funerar în Constanța și împrejurimi. Preluare rapidă de la domiciliu, spital sau IML. Servicii funerare autorizate, disponibile NON-STOP.",
    excerpt: "Transport funerar în Constanța și împrejurimi. Preluare rapidă de la domiciliu, spital sau IML. Servicii funerare autorizate, disponibile NON-STOP.",
    image: "/images/opel-van-front.jpg",
    date: "25 Februarie 2025",
    category: "Transport",
    readTime: "13 min",
    content: [
      { type: "paragraph", text: "În momentul pierderii unei persoane dragi, una dintre cele mai urgente și importante etape este organizarea transportului funerar. Fie că decesul a avut loc la domiciliu, într-un spital sau la IML, este esențial ca transportul să fie realizat rapid, legal și cu maxim respect." },
      { type: "paragraph", text: "Dacă te afli în Constanța, Lumina sau în localitățile din apropiere, acest ghid îți explică în detaliu ce presupune un serviciu profesionist de transport funerar în Constanța, care sunt obligațiile legale și cum alegi o firmă autorizată." },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei oferă transport funerar în Constanța, disponibil NON-STOP 24/7, intervenind prompt și ocupându-se de toate procedurile necesare." },
      { type: "heading", text: "Ce înseamnă transport funerar?" },
      { type: "paragraph", text: "Transportul funerar reprezintă preluarea și deplasarea persoanei decedate în condiții legale și sanitare conforme, folosind autovehicule special autorizate. Acesta poate include:" },
      { type: "list", items: ["Preluare de la domiciliu", "Preluare de la spital", "Preluare de la Institutul de Medicină Legală (IML)", "Transport către capelă", "Transport către biserică", "Transport către cimitir", "Transport interurban (între localități)"] },
      { type: "paragraph", text: "Un serviciu de transport funerar în Constanța trebuie să respecte normele sanitare și legislația în vigoare." },
      { type: "heading", text: "Când este necesar transportul funerar în Constanța?" },
      { type: "paragraph", text: "Transportul funerar este necesar în următoarele situații:" },
      { type: "subheading", text: "1. Deces la domiciliu" },
      { type: "paragraph", text: "După constatarea decesului de către medic, persoana decedată trebuie preluată și transportată către capelă sau altă locație stabilită de familie." },
      { type: "subheading", text: "2. Deces în spital" },
      { type: "paragraph", text: "Spitalul solicită ridicarea persoanei decedate într-un interval stabilit, iar transportul trebuie efectuat de o firmă autorizată." },
      { type: "subheading", text: "3. Cazuri IML" },
      { type: "paragraph", text: "În situațiile în care decesul este investigat de autorități, preluarea de la IML se face după finalizarea procedurilor legale." },
      { type: "paragraph", text: "În toate aceste situații, intervenția rapidă este esențială." },
      { type: "heading", text: "De ce este important să alegi o firmă autorizată pentru transport funerar în Constanța?" },
      { type: "paragraph", text: "Transportul funerar nu poate fi realizat de orice persoană sau cu orice autovehicul. Este necesară:" },
      { type: "list", items: ["Autorizație sanitară", "Mașini funerare omologate", "Respectarea normelor privind manipularea", "Personal instruit"] },
      { type: "paragraph", text: "Alegerea unei firme neautorizate poate duce la probleme legale și situații neplăcute." },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei respectă toate normele legale pentru transport funerar în Constanța și împrejurimi." },
      { type: "heading", text: "Cum se desfășoară preluarea decedatului?" },
      { type: "paragraph", text: "Un serviciu profesionist de transport funerar în Constanța urmează pași clari:" },
      { type: "list", items: ["Preluarea solicitării telefonice", "Confirmarea locației și situației", "Deplasarea echipei la adresă", "Manipularea cu respect și discreție", "Transportul către locația stabilită"] },
      { type: "paragraph", text: "Personalul trebuie să manifeste empatie și profesionalism, deoarece familia se află într-un moment vulnerabil." },
      { type: "heading", text: "Transport funerar local vs. transport funerar interurban" },
      { type: "subheading", text: "Transport funerar local – Constanța" },
      { type: "paragraph", text: "Include transportul în interiorul municipiului Constanța sau către localitățile apropiate (Lumina și împrejurimi). Este cel mai frecvent tip de transport solicitat." },
      { type: "subheading", text: "Transport funerar interurban" },
      { type: "paragraph", text: "În cazul în care persoana decedată trebuie transportată într-o altă localitate sau județ, sunt necesare documente suplimentare și respectarea unor condiții speciale." },
      { type: "paragraph", text: "O firmă cu experiență în servicii funerare în Constanța poate gestiona fără probleme aceste situații." },
      { type: "heading", text: "Ce documente sunt necesare pentru transport funerar?" },
      { type: "paragraph", text: "În general, sunt necesare:" },
      { type: "list", items: ["Certificatul constatator de deces", "Actul de identitate al persoanei decedate", "Documente suplimentare în caz de transport între localități"] },
      { type: "paragraph", text: "O casă funerară din Constanța oferă consultanță și verifică documentele înainte de transport." },
      { type: "heading", text: "Transport funerar și condiții sanitare" },
      { type: "paragraph", text: "Respectarea normelor sanitare este esențială. Autovehiculele funerare trebuie să fie:" },
      { type: "list", items: ["Special amenajate", "Igienizate corespunzător", "Echipate conform reglementărilor"] },
      { type: "paragraph", text: "Manipularea trebuie realizată în mod profesionist și discret." },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei acordă o atenție deosebită siguranței și respectului în fiecare intervenție." },
      { type: "heading", text: "Disponibilitate NON-STOP – De ce contează?" },
      { type: "paragraph", text: "Decesele nu pot fi programate. De aceea, este esențial ca firma aleasă pentru transport funerar în Constanța să fie disponibilă NON-STOP 24/7." },
      { type: "paragraph", text: "Intervenția rapidă:" },
      { type: "list", items: ["Reduce stresul familiei", "Respectă cerințele instituțiilor", "Asigură desfășurarea corectă a etapelor următoare"] },
      { type: "heading", text: "Transport funerar și organizarea completă a înmormântării" },
      { type: "paragraph", text: "De cele mai multe ori, transportul funerar face parte dintr-un pachet mai amplu de servicii funerare în Constanța. Acesta poate include:" },
      { type: "list", items: ["Îmbălsămare", "Aranjare și cosmetizare", "Capac frigorific", "Organizarea priveghiului", "Transport la biserică", "Transport la cimitir", "Manipulare sicriu"] },
      { type: "paragraph", text: "Este mult mai eficient ca toate serviciile să fie oferite de aceeași firmă." },
      { type: "heading", text: "Cum alegi corect o firmă de transport funerar în Constanța?" },
      { type: "paragraph", text: "Iată câteva criterii esențiale:" },
      { type: "subheading", text: "1. Intervenție rapidă" },
      { type: "paragraph", text: "Răspuns prompt la telefon și deplasare rapidă." },
      { type: "subheading", text: "2. Autorizare legală" },
      { type: "paragraph", text: "Verifică dacă firma este autorizată pentru transport funerar." },
      { type: "subheading", text: "3. Profesionalism" },
      { type: "paragraph", text: "Echipă discretă și respectuoasă." },
      { type: "subheading", text: "4. Servicii complete" },
      { type: "paragraph", text: "Ideal este să ofere și restul serviciilor funerare." },
      { type: "subheading", text: "5. Transparență" },
      { type: "paragraph", text: "Comunicare clară privind costurile." },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei oferă transport funerar autorizat în Constanța, Lumina și împrejurimi, intervenind rapid și gestionând toate detaliile." },
      { type: "heading", text: "Costuri transport funerar în Constanța" },
      { type: "paragraph", text: "Prețul poate varia în funcție de:" },
      { type: "list", items: ["Distanță", "Tipul serviciului", "Ora intervenției", "Servicii suplimentare incluse"] },
      { type: "paragraph", text: "Este recomandat să solicitați informații clare înainte de confirmarea serviciului." },
      { type: "heading", text: "Sprijin real în momente dificile" },
      { type: "paragraph", text: "Dincolo de transport, ceea ce contează este modul în care familia este tratată. O firmă profesionistă de servicii funerare în Constanța oferă:" },
      { type: "list", items: ["Respect", "Discreție", "Calm", "Organizare eficientă"] },
      { type: "paragraph", text: "Transportul funerar este primul pas dintr-un proces mai amplu, iar modul în care este gestionat poate influența întreaga experiență." },
      { type: "heading", text: "Concluzie" },
      { type: "paragraph", text: "Dacă ai nevoie de transport funerar în Constanța, este esențial să alegi o firmă autorizată, cu experiență și disponibilitate NON-STOP." },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei oferă:" },
      { type: "list", items: ["Preluare rapidă", "Transport funerar autorizat", "Servicii funerare complete", "Sprijin pentru acte și organizare"] },
      { type: "cta", text: "Sună NON-STOP la 0786 135 139" },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei – transport funerar și servicii funerare complete în Constanța, oferite cu respect și profesionalism." },
    ],
  },
  {
    slug: "pachete-funerare-constanta-optiuni-si-costuri",
    title: "Pachete funerare Constanța – Ce includ, cum alegi și ce costuri implică",
    metaTitle: "Pachete funerare Constanța – Opțiuni complete și personalizate 24/7",
    metaDescription: "Descoperă pachete funerare în Constanța: standard, complet sau personalizat. Servicii funerare NON-STOP, transparență și sprijin total.",
    excerpt: "Descoperă pachete funerare în Constanța: standard, complet sau personalizat. Servicii funerare NON-STOP, transparență și sprijin total.",
    image: "/images/showroom-detail.jpg",
    date: "1 Martie 2025",
    category: "Pachete",
    readTime: "15 min",
    content: [
      { type: "paragraph", text: "În momentele de pierdere, organizarea unei înmormântări poate deveni copleșitoare. Pe lângă durerea emoțională, apar numeroase decizii practice: preluarea decedatului, transportul funerar, alegerea sicriului, organizarea ceremoniei, actele necesare și multe alte detalii." },
      { type: "paragraph", text: "Pentru a simplifica procesul, multe firme oferă pachete funerare în Constanța, care includ toate serviciile esențiale într-o structură clară și organizată." },
      { type: "paragraph", text: "În acest articol îți explicăm:" },
      { type: "list", items: ["Ce includ pachetele funerare", "Care este diferența între pachet standard și complet", "Ce influențează costul unei înmormântări în Constanța", "Cum alegi corect o casă funerară în Constanța"] },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei oferă pachete funerare complete și personalizate în Constanța, Lumina și împrejurimi, disponibile NON-STOP 24/7." },
      { type: "heading", text: "Ce sunt pachetele funerare?" },
      { type: "paragraph", text: "Un pachet funerar reprezintă o combinație de servicii și produse incluse într-o ofertă organizată, menită să acopere toate etapele unei înmormântări." },
      { type: "paragraph", text: "Avantajele unui pachet funerar în Constanța:" },
      { type: "list", items: ["Organizare mai simplă", "Costuri mai clare", "Eliminarea stresului administrativ", "Toate serviciile într-un singur loc"] },
      { type: "paragraph", text: "În loc să contractezi separat transportul funerar, produsele și organizarea ceremoniei, alegi o soluție completă." },
      { type: "heading", text: "Ce includ pachetele funerare în Constanța?" },
      { type: "paragraph", text: "Un pachet funerar complet poate include:" },
      { type: "subheading", text: "Preluare și transport funerar" },
      { type: "list", items: ["Preluare decedat de la domiciliu, spital sau IML", "Transport funerar autorizat în Constanța", "Manipulare și așezare în sicriu", "Capac frigorific"] },
      { type: "subheading", text: "Pregătirea persoanei decedate" },
      { type: "list", items: ["Toaletare și igienizare", "Îmbrăcare", "Aranjare", "Cosmetizare", "Îmbălsămare (acolo unde este necesar)"] },
      { type: "subheading", text: "Produse funerare" },
      { type: "list", items: ["Sicriu (diverse modele)", "Lenjerie funerară", "Cruce", "Accesorii"] },
      { type: "subheading", text: "Organizare ceremonie" },
      { type: "list", items: ["Programare la capelă", "Colaborare cu biserica", "Transport la biserică și cimitir", "Manipulare sicriu la cimitir"] },
      { type: "subheading", text: "Servicii suplimentare" },
      { type: "list", items: ["Coroane și aranjamente florale", "Colivă și colaci", "Pachete pentru pomeni", "Consultanță pentru acte"] },
      { type: "heading", text: "Tipuri de pachete funerare în Constanța" },
      { type: "subheading", text: "1. Pachet funerar Standard" },
      { type: "paragraph", text: "Este o opțiune potrivită pentru familiile care doresc o organizare corectă, simplă și eficientă. Include de regulă:" },
      { type: "list", items: ["Preluare și transport funerar Constanța", "Manipulare", "Sicriu model standard", "Capac frigorific", "Consultanță pentru acte"] },
      { type: "paragraph", text: "Este o soluție echilibrată și accesibilă." },
      { type: "subheading", text: "2. Pachet funerar Complet" },
      { type: "paragraph", text: "Include toate serviciile esențiale, plus elemente suplimentare pentru o organizare fără griji. Poate include:" },
      { type: "list", items: ["Toate serviciile din pachetul standard", "Îmbălsămare", "Cosmetizare", "Organizare priveghi", "Produse funerare extinse", "Transport complet (capelă – biserică – cimitir)"] },
      { type: "paragraph", text: "Este alegerea potrivită pentru familiile care doresc ca totul să fie gestionat integral de o casă funerară din Constanța." },
      { type: "subheading", text: "3. Pachet funerar Personalizat" },
      { type: "paragraph", text: "Fiecare familie are tradiții, dorințe și bugete diferite. Un pachet personalizat permite:" },
      { type: "list", items: ["Alegerea tipului de sicriu", "Adăugarea serviciilor suplimentare", "Adaptarea la cerințe religioase", "Organizarea completă a pomenilor"] },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei oferă pachete funerare personalizate în Constanța, adaptate fiecărei situații." },
      { type: "heading", text: "Ce influențează costul unei înmormântări în Constanța?" },
      { type: "paragraph", text: "Costul unui pachet funerar în Constanța poate varia în funcție de:" },
      { type: "list", items: ["Tipul sicriului", "Necesitatea îmbălsămării", "Numărul serviciilor incluse", "Produse suplimentare (coroane, colivă etc.)", "Transport interurban (dacă este cazul)"] },
      { type: "paragraph", text: "Este important să alegi o firmă care oferă transparență și explicații clare privind costurile." },
      { type: "heading", text: "De ce este mai eficient să alegi un pachet complet?" },
      { type: "paragraph", text: "Alegerea unui pachet funerar complet în Constanța reduce:" },
      { type: "list", items: ["Stresul", "Timpul pierdut", "Riscul omiterii unor etape importante"] },
      { type: "paragraph", text: "Toate serviciile sunt coordonate de aceeași echipă, ceea ce asigură organizare coerentă și eficientă." },
      { type: "heading", text: "Pachete funerare și respectarea tradițiilor ortodoxe" },
      { type: "paragraph", text: "În Constanța, majoritatea ceremoniilor respectă tradiția ortodoxă. Un pachet funerar trebuie să includă:" },
      { type: "list", items: ["Organizarea slujbei", "Colivă și colaci", "Pachete pentru pomeni", "Respectarea ritualurilor specifice"] },
      { type: "paragraph", text: "Totodată, o casă funerară profesionistă trebuie să fie deschisă și altor confesiuni." },
      { type: "heading", text: "De ce să alegi o casă funerară din Constanța?" },
      { type: "paragraph", text: "Alegerea unei firme locale pentru pachete funerare în Constanța oferă avantaje clare:" },
      { type: "list", items: ["Intervenție rapidă", "Cunoașterea procedurilor locale", "Colaborare cu biserici și cimitire din zonă", "Sprijin personalizat"] },
      { type: "highlight", text: "Casa Funerară Sfântul Andrei oferă servicii funerare complete în Constanța, Lumina și împrejurimi." },
      { type: "heading", text: "Disponibilitate NON-STOP 24/7" },
      { type: "paragraph", text: "Un aspect esențial al pachetelor funerare este disponibilitatea. Suntem disponibili NON-STOP pentru:" },
      { type: "list", items: ["Preluare decedat", "Transport funerar", "Organizare înmormântare", "Consultanță acte"] },
      { type: "heading", text: "Cum alegi corect pachetul potrivit?" },
      { type: "paragraph", text: "Pentru a lua o decizie informată:" },
      { type: "list", items: ["Stabilește bugetul", "Analizează serviciile incluse", "Solicită explicații clare", "Alege o firmă cu experiență"] },
      { type: "paragraph", text: "O casă funerară din Constanța trebuie să ofere sprijin, nu presiune." },
      { type: "heading", text: "Sprijin real în momente dificile" },
      { type: "paragraph", text: "Un pachet funerar nu înseamnă doar servicii și produse. Înseamnă organizare, empatie și responsabilitate. O echipă profesionistă oferă:" },
      { type: "list", items: ["Calm", "Discreție", "Respect", "Sprijin continuu"] },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei tratează fiecare familie cu demnitate și seriozitate." },
      { type: "heading", text: "Concluzie" },
      { type: "paragraph", text: "Alegerea unui pachet funerar în Constanța este o decizie importantă, care influențează modul în care va fi organizată ceremonia și cât de ușor va trece familia prin acest proces." },
      { type: "paragraph", text: "Dacă ai nevoie de:" },
      { type: "list", items: ["Pachete funerare complete", "Transport funerar Constanța", "Servicii funerare NON-STOP", "Consultanță pentru acte"] },
      { type: "paragraph", text: "Suntem aici pentru tine." },
      { type: "cta", text: "Sună acum la 0786 135 139" },
      { type: "paragraph", text: "Casa Funerară Sfântul Andrei – pachete funerare și servicii funerare complete în Constanța, oferite cu respect și profesionalism." },
    ],
  },
  {
    slug: "acte-necesare-inmormantare-2026",
    title: "Acte Necesare pentru Înmormântare în 2026 – Lista Completă",
    excerpt: "Lista completă și actualizată a documentelor necesare pentru organizarea unei înmormântări în România.",
    image: null,
    date: "10 Iulie 2025",
    category: "Legislație",
    readTime: "6 min",
    content: null,
  },
  {
    slug: "traditii-funerare-romania",
    title: "Tradiții Funerare în România – Obiceiuri și Semnificații",
    excerpt: "Descoperă semnificația tradițiilor funerare românești și importanța respectării obiceiurilor moștenite.",
    image: null,
    date: "5 Iulie 2025",
    category: "Tradiții",
    readTime: "10 min",
    content: null,
  },
  {
    slug: "cum-sa-alegi-firma-pompe-funebre",
    title: "Cum Să Alegi o Firmă de Pompe Funebre de Încredere",
    excerpt: "Criterii importante pentru alegerea unei case funerare profesioniste și de încredere.",
    image: null,
    date: "28 Iunie 2025",
    category: "Sfaturi",
    readTime: "5 min",
    content: null,
  },
];

export const galleryImages = {
  flowers1: "/images/flowers1.jpg",
  flowers2: "/images/flowers2.jpg",
  coliva: "/images/coliva.jpg",
  van: "/images/van.jpg",
  mercedes: "/images/mercedes.jpg",
  heroBackground: "/images/hero-background.jpg",
  tricolorWreath: "/images/tricolor-wreath.jpg",
  parastasPackages: "/images/parastas-packages.jpg",
  churchInterior: "/images/church-interior.jpg",
  vanBranding: "/images/van-branding.jpg",
  showroom: "/images/showroom.jpg",
  celestial: "/images/celestial.jpg",
  soimiiAward: "/images/soimii-award.jpg",
  opelVanFront: "/images/opel-van-front.jpg",
  showroomCoffinsWreaths: "/images/showroom-coffins-wreaths.jpg",
  showroomDetail: "/images/showroom-detail.jpg",
  waxCandle: "/images/wax-candle.jpg",
  sfAndreiBiserica: "/images/sf-andrei-biserica.jpg",
  sfAndreiGrau: "/images/sf-andrei-grau.jpg",
  sfAndreiCruce: "/images/sf-andrei-cruce.jpg",
  sfAndreiVitraliu: "/images/sf-andrei-vitraliu.jpg",
  sfAndreiIcoana: "/images/sf-andrei-icoana.jpg",
  clothingWoman: "/images/clothing-woman.jpg",
  shoesWoman: "/images/shoes-woman.jpg",
  shoesMan: "/images/shoes-man.jpg",
  clothingMan: "/images/clothing-man.jpg",
};

export const googleProfile = {
  rating: 5.0,
  totalReviews: 11,
  soimiiScore: 8.6,
  soimiiReviews: 12,
  medals: ["Laureatul Proiectului 2025", "Laureatul Proiectului 2024", "Medalia de Aur 2023"],
  googleMapsUrl: "https://www.google.com/maps/place/Casa+Funerara+Sfantul+Andrei",
  reviews: [
    {
      author: "Maria D.",
      rating: 5,
      text: "O echipă de profesioniști, recomand! S-au ocupat de absolut tot cu multă grijă și respect. În cel mai greu moment, au fost un sprijin real.",
      date: "Ianuarie 2026",
      source: "Google",
    },
    {
      author: "Ion P.",
      rating: 5,
      text: "Servicii impecabile. Ne-au ajutat cu toate actele, transportul și organizarea completă. Prețuri corecte și transparente.",
      date: "Decembrie 2025",
      source: "Google",
    },
    {
      author: "Elena M.",
      rating: 5,
      text: "Profesionalism desăvârșit și empatie reală. Au fost disponibili non-stop și au gestionat totul cu demnitate. Mulțumim din suflet.",
      date: "Noiembrie 2025",
      source: "Google",
    },
    {
      author: "Gheorghe R.",
      rating: 5,
      text: "Am apelat la ei într-un moment foarte dificil. Răspuns imediat, organizare rapidă, tot ce era nevoie. Recomand cu încredere!",
      date: "Octombrie 2025",
      source: "Google",
    },
    {
      author: "Ana C.",
      rating: 5,
      text: "Foarte mulțumiți de serviciile oferite. Personal amabil și profesionist. Au fost lângă noi pas cu pas.",
      date: "Septembrie 2025",
      source: "Google",
    },
    {
      author: "Vasile T.",
      rating: 5,
      text: "Singura firmă care a răspuns la telefon la 3 noaptea și a venit imediat. Recunoștință totală.",
      date: "August 2025",
      source: "Google",
    },
  ],
};

export const testimonials = [
  {
    text: "În cel mai greu moment al vieții noastre, echipa Sfântul Andrei a fost alături de noi cu profesionalism și căldură. Le suntem recunoscători pentru tot sprijinul.",
    author: "Familia M.",
    location: "Constanța",
  },
  {
    text: "S-au ocupat de absolut tot, de la acte până la ceremonie. Am simțit că suntem pe mâini bune în fiecare moment.",
    author: "Familia P.",
    location: "Lumina",
  },
  {
    text: "Profesionalism desăvârșit și empatie reală. Au fost disponibili non-stop și au gestionat totul impecabil.",
    author: "Familia D.",
    location: "Constanța",
  },
];
